import CustomModal from './custom-modal'

export default CustomModal
